/**
 * @generated SignedSource<<19a115382f8ee94814c5db9d18015e2a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
export type FocusSubscription$variables = {
  storecastId: string;
};
export type FocusSubscription$data = {
  readonly storecastFocus: {
    readonly sessionId: string | null;
    readonly setAt: string | null;
    readonly subject: {
      readonly detailItemId: string | null;
      readonly nodeId: string;
      readonly scale: number | null;
      readonly transformX: number | null;
      readonly transformY: number | null;
    };
  } | null;
};
export type FocusSubscription = {
  response: FocusSubscription$data;
  variables: FocusSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storecastId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "storecastId",
        "variableName": "storecastId"
      }
    ],
    "concreteType": "StorecastNewFocus",
    "kind": "LinkedField",
    "name": "storecastFocus",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "setAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "sessionId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "StorecastNewFocusSubject",
        "kind": "LinkedField",
        "name": "subject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "detailItemId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nodeId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "scale",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transformX",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "transformY",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FocusSubscription",
    "selections": (v1/*: any*/),
    "type": "Subscription",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FocusSubscription",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ad0a14cf70e993098f1da3b7e213cefd",
    "id": null,
    "metadata": {},
    "name": "FocusSubscription",
    "operationKind": "subscription",
    "text": "subscription FocusSubscription(\n  $storecastId: ID!\n) {\n  storecastFocus(storecastId: $storecastId) {\n    setAt\n    sessionId\n    subject {\n      detailItemId\n      nodeId\n      scale\n      transformX\n      transformY\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "30bb29ea5a23edd42e12630c94083855";

export default node;
